import { createContext, type ReactNode, useContext, useMemo } from "react"

type ContextValue = {
  enabled: boolean
}

const CollaborationStateContext = createContext<ContextValue>({
  enabled: false,
})

type CollaborationStateProviderProps = {
  enabled: boolean
  children?: ReactNode
}

export function CollaborationStateProvider(
  props: CollaborationStateProviderProps,
) {
  const { enabled, children } = props

  const value = useMemo(() => ({ enabled }), [enabled])

  return (
    <CollaborationStateContext.Provider value={value}>
      {children}
    </CollaborationStateContext.Provider>
  )
}

export function useCollaborationState() {
  return useContext(CollaborationStateContext)
}
